const b2bEn = {
  en: {
    nb: {
      new_business: 'New Business',
      service_records: 'Service Records',
      clients: 'Clients',
      reports: 'Reports',
      commissions: 'Commissions',
      my_profile: 'My Profile',
      mdrt: 'MDRT',
      keywords: 'Appl. Ref. No.  /  Policy No.  /  Client Name  /  Partner',
      insurance_plan: 'Insurance Plan',
      investment_link: 'ILAS',
      fund_platform: 'Investment',
      transfer_in: 'Transfer In',
      private_bank: 'Private Bank',
      trust: 'Trust',
      legend: 'Legend',
      stage_1: 'Stage 1',
      stage_2: 'Stage 2',
      stage_3: 'Stage 3',
      stage_4: 'Stage 4',
      stage_5: 'Stage 5',
      stage_6: 'Stage 6',
      stage_7: 'Stage 7',
      stage_other: 'Other',
      stage_1_desc: 'Application received at {{siteShortName}} office',
      stage_2_desc: 'Outstanding item required from {{siteShortName}}',
      stage_3_desc: 'Application sent to product provider',
      stage_4_desc: 'Outstanding documents required by the product provider',
      stage_5_desc: 'Application completed and waiting for policy issue',
      stage_6_desc: 'Policy arrived at {{siteShortName}} office / Policy couriered to client’s correspondence address by service provider',
      stage_7_desc: 'Received original policy acknowledgment receipt from client / Account Opened',
      stage_other_desc: 'Application is cancelled',
      oaa: 'Online Application Assistance',
      new_policy_detail: 'New Policy Detail',
      service_record_detail: 'Service Record Detail',
      statement: 'Statement',
      close: 'Close',
      table_fields: {
        policy_no: 'Application / Policy No / Plan Name *',
        client: 'Client',
        insured: 'Insured',
        modal_premium: 'Modal Premium',
        plan_start_date: 'Plan Start Date',
        app_rec_date: 'App Rec Date *',
        stage: 'Stage *',
        consultant: 'Partner *',
        details: 'Details',
      },
    },
    clients: {
      keywords: 'Client Name  /  Client Code  /  Policy No.  /  Plan Name  /  Partner',
      exclude_policy_status: 'Exclude',
      fund_keywords: 'Fund Name  /  Fund Code',
      client_product_type: 'Product Type',
      client_detail: 'Client Detail',
      documents: 'Documents',
      table_fields: {
        client: 'Client *',
        policy_no: 'Application / Policy No / Plan Name *',
        insured: 'Insured',
        modal_premium: 'Modal Premium',
        status: 'Status *',
        consultant: 'Partner *',
        details: 'Details',
      },
    },
    sr: {
      keywords: 'Policy No./ Client Name',
      export_excel: 'Export',
      sr_all: '- ALL -',
      sr_status: 'Status',
      sr_type: 'Type',
      table_fields: {
        policy_no: 'Application / Policy No / Plan Name *',
        client: 'Client',
        insured: 'Insured',
        sr_type: 'Service Type',
        sr_status: 'Status *',
        created_date: 'Created Date *',
        complete_date: 'Complete Date *',
        consultant: 'Partner',
        details: 'Details',
      },
    },
    my_profile: {
      title: 'My Profile',
      subtitle: 'The below information is for {{siteName}} record only.',
      name: 'Name',
      code: 'Partner Code',
      op_email: 'Operation Email',
      ac_email: 'Accounting Email',
      contract_addr: 'Contract Address',
      corr_addr: 'Corresponding Address',
      remark: 'If you would like to update the above contact information, please complete the "Change of Contact Details Form" and email it to relevant servicing team.',
    },
    mdrt: {
      title: 'MDRT',
      subtitle: 'The below information is for {{siteName}} record only.',
    },
    commission: {
      issue_month: 'Issue Month',
      pdf_version: 'PDF version',
    },
    onlineAppl: {
      producer_info: 'Producer Information and Objectives',
      information: 'Information',
      save: 'Save',
      submit: 'Submit',
    },
    layout: {
      welcome: 'Welcome, ',
    },
    statement: {
      provider_statement: 'Transaction Statement / Statement from Product Provider',
      other_policies: 'Choose other policies',
      choose_month: 'Choose Month *',
      choose_currency: 'Choose Currency',
      pdf_version: 'PDF Version',
      last_6_month_remarks: '* You can download the statement of the last six months',
    },
  },
};

export default b2bEn;
